import AllConsents from '../AllConsents/AllConsents'
import './Dashboard.css'
const Dashboard = () => {

    return (
        <div className='dashboard'>
            <AllConsents />
        </div>
    )
}

export default Dashboard
